var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("ID CARD")]),_c('h4',[_vm._v("An identification card issued by HMI to members which bears the effectivity date of membership and name, signature, designated hospital and other matters relevant to membership.")])])
}]

export { render, staticRenderFns }